import PropTypes from 'prop-types';
import { NODE_ENV } from '@Constants/BuildInfo';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';

function check(rules = {}, data = {}, objectName = '') {
  if (NODE_ENV === 'dev') {
    const props = {};
    Object.keys(rules).forEach((ns) => {
      props[ns] = getValueByNs(data, ns);
    });
    return PropTypes.checkPropTypes(rules, data, 'property', objectName);
  }
  return undefined;
}

const ObjectValidator = { check };

export default ObjectValidator;
